import { render } from "./ExtractionFields.vue?vue&type=template&id=fe31d7ca&scoped=true"
import script from "./ExtractionFields.vue?vue&type=script&lang=js"
export * from "./ExtractionFields.vue?vue&type=script&lang=js"

import "./ExtractionFields.vue?vue&type=style&index=0&id=fe31d7ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe31d7ca"]])

export default __exports__